module.exports = __webpack_public_path__ + "img/icon-success.8a01b682.jpg";